import { createSelector } from "reselect";
import get from "lodash.get";
import { createPolicyForInternalNameSelector } from "src/selectors/data_selectors";

//Constants
import { policyInternalNames } from "src/constants";

/**
 * Memoized selector to determine if payer dashboard is enabled for dashboard
 */

export const payerDashboardEnabledSelector = createSelector(
  createPolicyForInternalNameSelector(
    policyInternalNames.payerDashboardEnabled
  ),
  policy => {
    return get(policy, "attributes.policyValue", false);
  }
);
